import React from 'react';

import { Flex, Grid, ScrollArea, Space } from '@mantine/core';
import { CallAnalysis } from 'pages/ManageSmartAssistant/Sections/ConversationSections/VoiceCallsSection/IndividualVoiceCallConversationView/SummaryTab/CallAnalysis';
import { CallerInformation } from 'pages/ManageSmartAssistant/Sections/ConversationSections/VoiceCallsSection/IndividualVoiceCallConversationView/SummaryTab/CallerInformation';
import { CallSummary } from 'pages/ManageSmartAssistant/Sections/ConversationSections/VoiceCallsSection/IndividualVoiceCallConversationView/SummaryTab/CallSummary';
import { SummaryItemList } from 'pages/ManageSmartAssistant/Sections/ConversationSections/VoiceCallsSection/IndividualVoiceCallConversationView/SummaryTab/SummaryItemList';
import { SummarySection } from 'pages/ManageSmartAssistant/Sections/ConversationSections/VoiceCallsSection/IndividualVoiceCallConversationView/SummaryTab/SummarySection';
import { useTranslation } from 'react-i18next';
import { Conversation } from 'shared/interfaces/Conversation';

interface SummaryTabProps {
  conversation: Conversation;
}

export function SummaryTab({ conversation }: SummaryTabProps) {
  const { t } = useTranslation();

  const voiceCallAnalysis = conversation.analysis;

  if (!voiceCallAnalysis) return null;

  return (
    <Flex direction="column" h="100%">
      <ScrollArea style={{ flex: 1 }} type="never" pb={100}>
        <Grid mb="md" h={150}>
          <Grid.Col span={voiceCallAnalysis.extractedData ? 9 : 12}>
            <SummarySection title={t('SMART_ASSISTANT.VOICE_CALLS_SECTION.SUMMARY_TAB.SUMMARY_SECTION.TITLE')}>
              <CallSummary summary={voiceCallAnalysis?.summary} />
            </SummarySection>
          </Grid.Col>
          {voiceCallAnalysis?.extractedData && (
            <Grid.Col span={3}>
              <CallAnalysis extractedData={voiceCallAnalysis.extractedData} />
            </Grid.Col>
          )}
        </Grid>

        <Space h="xs" />

        <Grid mb="md">
          <Grid.Col span={12}>
            <SummarySection title={t('SMART_ASSISTANT.VOICE_CALLS_SECTION.SUMMARY_TAB.KEY_POINTS_SECTION.TITLE')}>
              <SummaryItemList
                summaryItems={voiceCallAnalysis?.extractedData?.keyPoints}
                emptyMessage={t('SMART_ASSISTANT.VOICE_CALLS_SECTION.SUMMARY_TAB.KEY_POINTS_SECTION.EMPTY_STATE')}
              />
            </SummarySection>
          </Grid.Col>
          <Grid.Col span={12}>
            <SummarySection title={t('SMART_ASSISTANT.VOICE_CALLS_SECTION.SUMMARY_TAB.NEXT_STEPS_SECTION.TITLE')}>
              <SummaryItemList
                summaryItems={voiceCallAnalysis?.extractedData?.nextSteps}
                emptyMessage={t('SMART_ASSISTANT.VOICE_CALLS_SECTION.SUMMARY_TAB.NEXT_STEPS_SECTION.EMPTY_STATE')}
              />
            </SummarySection>
          </Grid.Col>
          <Grid.Col span={12}>
            <SummarySection
              title={t('SMART_ASSISTANT.VOICE_CALLS_SECTION.SUMMARY_TAB.CALLER_INFORMATION_SECTION.TITLE')}>
              <CallerInformation phoneNumber={conversation.voiceCall?.callerPhoneNumber} />
            </SummarySection>
          </Grid.Col>
        </Grid>
      </ScrollArea>
    </Flex>
  );
}
